import { query } from 'src/utils/request';

// 经办人-查询申报单详情（绩效变更入口查询接口）
export async function getAgentBudgetPerformReportDetail(params) {
  return query('/zlb/budget/perform/report/agent/detail-with-change', {
    params,
  });
}

// 经办人-查询绩效变更记录（最新一条绩效变更申请单详情）
export async function getAgentBudgetPerformChangeRecord(params) {
  return query('/zlb/budget/perform/change/agent/detail', {
    params,
  });
}

// 审批人-查询绩效变更详情
export async function getAuditBudgetPerformChangeRecord(params) {
  return query('/zlb/budget/perform/change/audit/detail', {
    params,
  });
}
